import { FC } from 'react';
import styled from '@emotion/styled';
import { NakedButton, Text } from 'roo-ui/components';

import { DetailsBooking } from 'types';
import { useHistory } from 'react-router';
import * as links from 'lib/links';
import { FLAG_CHANGE_DATE, FLAG_CHANGE_DATE_REQUEST } from 'config';
import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { useBookingDetailsPageContext } from '../../../contextProvider/BookingDetailsPageContextProvider';

const InlineFlexButton = styled(NakedButton)`
  display: inline-flex;
  align-items: center;
`;

interface ChangeDatesButtonProps {
  booking: DetailsBooking;
}

const ChangeDatesButton: FC<ChangeDatesButtonProps> = ({ booking }) => {
  const { push } = useHistory();
  const {
    modals: { adyenMigrationActionableModal },
  } = useBookingDetailsPageContext();
  const { isDateAmendableInApp, isChangeDatesRequestEnabled, isFinalising } = booking.flags;

  const targetPath =
    isDateAmendableInApp && FLAG_CHANGE_DATE
      ? links.getChangeDatesPageLink(booking.id)
      : isChangeDatesRequestEnabled && FLAG_CHANGE_DATE_REQUEST
      ? links.getChangeDatesRequestPageLink(booking.id)
      : false;

  if (!targetPath || isFinalising) {
    return null;
  }

  const onClick = () => {
    tracking.changeDatesLinkSelected();
    if (adyenMigrationActionableModal.isActiveModal) {
      adyenMigrationActionableModal.openModal();
    } else {
      push(targetPath);
    }
  };

  return (
    <InlineFlexButton onClick={onClick} color="brand.primary" aria-label="Change Dates Button" mt="3" data-testid="change-dates-button">
      <Text fontSize="sm">Change dates</Text>
    </InlineFlexButton>
  );
};

export default ChangeDatesButton;
